<div class="container">
    <div class="row justify-content-center">
        <div class="col-lg-6 col-md-4 col-12">
            <div class="card p-3">
                <p>ลิ้งสำหรับลูกค้าใช้งาน</p>
                <div class="input-icon-end">
                    <input type="text" class="form-control" disabled [value]="textURi">
                    <span class="material-symbols-outlined pointer" (click)="copyText()">
                        content_copy
                    </span>
                </div>
                <br>
                <p>QR CODE สำหรับลูกสแกนเข้าใช้งาน</p>
                <qrcode [qrdata]="this.textURi" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
        </div>
    </div>
</div>